import { Col, Radio, RadioChangeEvent, Row } from 'antd'
import { useChangeCommunityStatus } from 'api/Community/CommunityCreation'
import { useChangeExternalStatus } from 'api/External/External'
import { infoMessage } from 'api/global'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { communityStore } from 'state/event/community'
import { myStore } from 'state/store'
import { EventStatus } from 'types/event/eventStep5'

const StatusModal: React.FC = () => {
  const history = useHistory()
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const {
    statusModalVisible,
    setStatusModalVisible,
    communityData,
    setCommunityStepCounter,
  } = communityStore(store => ({
    statusModalVisible: store.statusModalVisible,
    setStatusModalVisible: store.setStatusModalVisible,
    communityData: store.communityData,
    setCommunityStepCounter: store.setCommunityStepCounter,
  }))
  const [status, setStatus] = useState<EventStatus>(
    communityData?.status || 'draft',
  )
  const { mutate: changeCommunityStatus } = useChangeCommunityStatus()

  const handleRadioChange = (e: RadioChangeEvent) => {
    const selected = e.target.value as EventStatus

    if (selected === 'draft') {
      setStatus(selected)
      return
    }
    if (communityData.organization.status !== 'approved') {
      infoMessage(
        'Organization is not approved yet! Only allowed to change status to "draft"',
      )
      return
    }
    setStatus(selected)
  }
  const handleSubmit = () => {
    setModalBtnLoader(true)
    changeCommunityStatus(
      { payload: { status: status }, communityId: communityData._id },
      {
        onSuccess: () => {
          setCommunityStepCounter(0)
          setModalBtnLoader(false)
          history.push(`/spaces?page=1&limit=10`)
          setStatusModalVisible(false)
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      },
    )
  }
  return (
    <>
      <CustomModal
        openModal={statusModalVisible}
        closeModal={setStatusModalVisible}
        title="Status"
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText="Create community"
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <div>
          <Radio.Group value={status} onChange={handleRadioChange}>
            <Row>
              <Col className="d-flex justify-between align-items-start mt-20">
                <div>
                  <h2 className="text-16 w-600">Draft</h2>
                  <p className="text-14 w-400 text-gray mt-5px">
                    Only visible to organizers
                  </p>
                </div>
                <Radio className="radio mr-0" value={'draft'} />
              </Col>
            </Row>
            {communityData.organization.status === 'approved' && (
              <div>
                <Row>
                  <Col className="d-flex justify-between align-items-start mt-20">
                    <div>
                      <h2 className="text-16 w-600">Private</h2>
                      <p className="text-14 w-400 text-gray mt-5px">
                        Only visible by shared link
                      </p>
                    </div>
                    <Radio className="radio mr-0" value={'private'} />
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex justify-between align-items-start mt-20">
                    <div>
                      <h2 className="text-16 w-600">Following</h2>
                      <p className="text-14 w-400 text-gray mt-5px">
                        Visible to all families following the organization
                      </p>
                    </div>
                    <Radio className="radio mr-0" value={'following'} />
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex justify-between align-items-start mt-20">
                    <div>
                      <h2 className="text-16 w-600">Subscribed</h2>
                      <p className="text-14 w-400 text-gray mt-5px">
                        Visible to all families subscribed and approved the
                        organization
                      </p>
                    </div>
                    <Radio className="radio mr-0" value={'subscribed'} />
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex justify-between align-items-start mt-20">
                    <div>
                      <h2 className="text-16 w-600">Mentor social</h2>
                      <p className="text-14 w-400 text-gray mt-5px">
                        Visible to Mentors on their separate app
                      </p>
                    </div>
                    <Radio className="radio mr-0" value={'mentor_social'} />
                  </Col>
                </Row>
                <Row>
                  <Col className="d-flex justify-between align-items-start mt-20">
                    <div>
                      <h2 className="text-16 w-600">Public</h2>
                      <p className="text-14 w-400 text-gray mt-5px">
                        Visible to all families
                      </p>
                    </div>
                    <Radio className="radio mr-0" value={'public'} />
                  </Col>
                </Row>
              </div>
            )}
          </Radio.Group>
        </div>
      </CustomModal>
    </>
  )
}

export default StatusModal
